export const ADD_HIGH_SCHOOL = 'ADD_HIGH_SCHOOL';
export const DELETE_HIGH_SCHOOL = 'DELETE_HIGH_SCHOOL';
export const ADD_STUDENT_HIGH_SCHOOL = 'ADD_STUDENT_HIGH_SCHOOL';
export const DELETE_STUDENT_HIGH_SCHOOL = 'DELETE_STUDENT_HIGH_SCHOOL';